jQuery(function($) {
	const steps = $('section.elearning-step');
	var iCurrentStep = 0;
	var currentStep = $(steps[iCurrentStep]);
	var previousStep;



	$('.elearning-wrap').on('click', '.js-btn-elearning-step', function() {
		//mark step as finished
		//open up next
		iCurrentStep += 1;
		currentStep = $(steps[iCurrentStep]);
		previousStep = $(steps[iCurrentStep-1]);

		currentStep.find('.js-elearning-content').removeClass('hidden');
		previousStep.find('.js-check').addClass('opacity-100');

		$(this).addClass('hidden'); //hide this button
		//scroll to next
		currentStep[0].scrollIntoView({
			behavior: "smooth"
			//TODO: this isn't supported in IE or desktop safari. If needed, do jQuery way instead. Ref: https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
		});
		if(window.gtag) {
			if(iCurrentStep === 1) {
				gtag('event', 'course_started', {
					course_name: document.title
				});
			} else if(iCurrentStep == steps.length - 1) {
				gtag('event', 'course_finished', {
					course_name: document.title
				});
			}
		}
	});

	//if in elearning mode, close all but the first one on page load
	$('.js-elearning-content').each(function(i) {
		if(i > 0) {
			$(this).addClass('hidden');
		}
	});

	$('.button-wrapper').each(function() {
		var $wrapper = $(this);
		var bAnswer = $wrapper.data('answer');
		var $displayAns = $wrapper.find('.js-true-answer');
		var $answerText = $wrapper.siblings('.question-wrapper').children('.js-answer');
		$wrapper.on('click', '.js-selftest-true', function(e) {
			$(this).addClass('bg-siren text-white');
			$(this).siblings('.js-selftest-false').removeClass('bg-siren text-white');

			if(bAnswer) {
				$displayAns.addClass('correct').removeClass('hidden incorrect');
			} else {
				$displayAns.addClass('incorrect').removeClass('hidden correct');
			}
			$answerText.removeClass('hidden');
		});
		$wrapper.on('click', '.js-selftest-false', function(e) {
			$(this).addClass('bg-siren text-white');
			$(this).siblings('.js-selftest-true').removeClass('bg-siren text-white');
			if(bAnswer) {
				$displayAns.addClass('incorrect').removeClass('hidden correct');
			} else {
				$displayAns.addClass('correct').removeClass('hidden incorrect');
			}
			$answerText.removeClass('hidden');
		});
		$answerText.prepend('<span class="font-primary-bold">' + (bAnswer ? 'Sant' : 'Falskt') + '.</span> ');
	});

});
